import React, { useState } from 'react';
import Spacer from 'features/shared/Spacer';
import StatusBarWrapper from '../components/StatusBarWrapper';
import { TablePlateControls } from 'features/monitoring/components/TablePlateControls';
import PercentsTable from 'features/monitoring/percents/PercentsTable';
import { Plate, SubHeader } from 'features/shared/ui/Page';
import { PlateProps, subjectOptions, testRoundsOptions } from 'features/monitoring/models';
import { KnowledgeMonitoringApi } from 'api';
import LoaderComponent from 'features/shared/Loader';
import { usePercentsTableProps } from 'features/monitoring/percents/usePercentsTableProps';

const reportText = (
  <>
    Вы можете скачать отчет о прошедших тестирование
    <br /> учениках по школам в таблице
  </>
);

const Component = ({ tests, isRegion }: PlateProps) => {
  const [subject, setSubject] = useState(subjectOptions[0]);
  const [testRound, setTestRound] = useState(testRoundsOptions[0]);
  const tableProps = usePercentsTableProps(isRegion, tests, subject.id, testRound.id);
  const selectedTest = tests.find((test) => test.test_name === testRound.id && test.subject === subject.id);

  return (
    <Plate>
      <SubHeader>Процент правильно выполненных тестов</SubHeader>
      {!tableProps ? (
        <LoaderComponent />
      ) : (
        <>
          <Spacer size={40} />
          <TablePlateControls
            subject={subject}
            setSubject={setSubject}
            testRound={testRound}
            setTestRound={setTestRound}
            reportText={reportText}
            getReport={() => KnowledgeMonitoringApi.getProgressesReportXlsx()}
            fileName="срезы-выполнение.xlsx"
            loggerPrefix="correct_completed_test"
            loggerPrefixTranslate="Процент правильно выполненных тестов"

          />
          <Spacer size={10} />
          {selectedTest && (
            <StatusBarWrapper testStart={selectedTest.test_start} testEnd={selectedTest.test_end}>
              <PercentsTable {...tableProps} showSchools={!isRegion} />
            </StatusBarWrapper>
          )}
        </>
      )}
    </Plate>
  );
};

export default Component;
